

import React from 'react'
import { SkyInformationPopover } from './SkyPopover';

export const ClaimIncidentDocPopover = (props) => {
  return (
      <SkyInformationPopover eventId={'claim-incident-doc'}>
          <div className="text-small">Please provide any documentation you have such as footage from the flight,</div>
          <div className="text-small">a police report, and anything else which can better help us understand the details of the incident</div>
        </SkyInformationPopover>
  );
}